// Copyright Square, Inc.
export var userJourneyEventMonitors = [
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositEnterAmount",
        requiredParameters: {
            "enter_method": "SELECTED",
        },
        trigger: { type: 'variant', variantName: 'Selected' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositEnterAmount",
        requiredParameters: {
            "enter_method": "KEYPAD",
        },
        trigger: { type: 'variant', variantName: 'Keypad' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "passcode_verification",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'passcode-verification' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "InstrumentSelectionBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'instrument-selection' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "provide_ssn",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'provide-ssn' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'eidv-introduction' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'didv' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "verify_ssn_blocker",
        },
        trigger: { type: 'friction', signalName: 'tax_id_verify_ssn' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
        },
        trigger: { type: 'friction', signalName: 'tax_id_w9_consent' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_BACKUP_WITHHOLDING_BLOCKER",
        },
        trigger: { type: 'friction', signalName: 'tax_id_w9_backup_withholding' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CashTaxIdentityIncorrectInformationBlocker",
        },
        trigger: { type: 'friction', signalName: 'tax_id_incorrect_information' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'friction', signalName: 'unspecified_termination_blocker' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "MARKET_SELL_SUCCESS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CashTaxIdentityIncorrectInformationBlocker",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
        },
        trigger: { type: 'variant', variantName: 'EIDV' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
        },
        trigger: { type: 'variant', variantName: 'DIDV' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "denylistedOnboardingBlocker",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "verify_ssn_blocker",
        },
        trigger: { type: 'friction', signalName: 'stock_sale_id_verify_ssn' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'friction', signalName: 'unspecified_termination_blocker' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "passcode_verification",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'passcode-verification' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "InstrumentSelectionBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'instrument-selection' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "provide_ssn",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'provide-ssn' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'eidv-introduction' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'didv' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "standardCashOutConfirmedBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "instantCashOutDomainApiConfirmedBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositCanceled",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeStart",
        requiredParameters: {
            "side": "SELL",
            "source_asset": "btc",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
            "blocker_action": "INTERNAL_NAVIGATION_ACTION",
        },
        trigger: { type: 'friction', signalName: 'tax_id_navigate_to_edit_personal_information' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
            "blocker_action": "INTERNAL_NAVIGATION_ACTION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeClose",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeComplete",
        requiredParameters: {
            "order_type": "STANDARD",
        },
        trigger: { type: 'tag', tagName: 'market-order' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeComplete",
        requiredParameters: {
            "order_type": "LIMIT",
        },
        trigger: { type: 'tag', tagName: 'limit-order' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "FormBlockerLaunchShow",
        requiredParameters: {
            "blockerId": "IDENTITY_HUB_INITIATE",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "IDV_END_RESULT",
            "status": "SUCCESS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'discover' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_ACTIVITY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-activity' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-discover' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_FAVORITES",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-favorites' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "APP_LINK",
        },
        trigger: { type: 'variant', variantName: 'client-route' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "APP_SHORTCUT",
        },
        trigger: { type: 'variant', variantName: 'app-shortcut' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "SIRI_DRAFT_PAYMENT",
        },
        trigger: { type: 'variant', variantName: 'siri' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "AMOUNT_FIRST",
        },
        trigger: { type: 'variant', variantName: 'amount-first' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "CashRequestCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'discover' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_ACTIVITY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-activity' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-discover' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_FAVORITES",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-favorites' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "APP_LINK",
        },
        trigger: { type: 'variant', variantName: 'client-route' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "APP_SHORTCUT",
        },
        trigger: { type: 'variant', variantName: 'app-shortcut' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "SIRI_DRAFT_PAYMENT",
        },
        trigger: { type: 'variant', variantName: 'siri' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "AMOUNT_FIRST",
        },
        trigger: { type: 'variant', variantName: 'amount-first' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "CashSendCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeStart",
        requiredParameters: {
            "order_side": "SELL",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "HOME",
        },
        trigger: { type: 'variant', variantName: 'origin-home' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "SEARCH",
        },
        trigger: { type: 'variant', variantName: 'origin-search' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "CATEGORY",
        },
        trigger: { type: 'variant', variantName: 'origin-category' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "STOCK_PICKER",
        },
        trigger: { type: 'variant', variantName: 'origin-stock-picker' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "PUSH_NOTIFICATION",
        },
        trigger: { type: 'variant', variantName: 'origin-push-notification' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "CLIENT_ROUTE",
        },
        trigger: { type: 'variant', variantName: 'origin-client-route' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "WELCOME_TILES",
        },
        trigger: { type: 'variant', variantName: 'origin-welcome-tiles' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "ROUND_UP",
        },
        trigger: { type: 'variant', variantName: 'origin-round-up' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "INVEST_SEARCH",
        },
        trigger: { type: 'variant', variantName: 'origin-invest-search' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "ETF_HOLDINGS",
        },
        trigger: { type: 'variant', variantName: 'origin-etf-holdings' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockViewViewStockDetails",
        requiredParameters: {
            "origin": "ETF_HOLDINGS_DETAILS",
        },
        trigger: { type: 'variant', variantName: 'origin-etf-holdings-details' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "SELL",
            "order_type": "ONE_OFF",
        },
        trigger: { type: 'variant', variantName: 'one-off-sale' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "SELL",
            "order_type": "CUSTOM",
        },
        trigger: { type: 'variant', variantName: 'custom-order' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawEnterAmount",
        requiredParameters: {
            "enter_method": "SELECTED",
        },
        trigger: { type: 'variant', variantName: 'Selected' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawEnterAmount",
        requiredParameters: {
            "enter_method": "KEYPAD",
        },
        trigger: { type: 'variant', variantName: 'Keypad' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
];
export var relevantEndpointsByJourneyName = {
    "add-money": [],
    "bitcoin-sell": [
        "/cash-app/crypto/invest/exchange",
    ],
    "identity-verification": [
        "/cash-app/device-attestation/validate-play-integrity-attestation",
        "/cash-app/device-attestation/validate-app-attest-attestation",
        "/cash-app/device-attestation/issue-challenge",
    ],
    "login": [
        "/cash-app/semaphore/get-onboarding-config",
        "/2.0/cash/initiate-session",
        "/cash-app/security/1.0/get-linked-accounts",
        "/cash-app/security/1.0/get-login-scenario-plan",
        "/2.0/cash/get-app-config",
        "/2.0/cash/get-profile",
    ],
    "open-the-app": [
        "/2.0/cash/check-version",
        "/2.0/cash/get-app-config",
        "/2.0/cash/get-scenario-plan",
        "/2.0/cash/initiate-session",
        "/cash-app/device-attestation/validate-app-attest-attestation",
        "/cash-app/device-attestation/validate-play-integrity-attestation",
        "/cash-app/onboarding/1.0/get-pre-sign-in-data",
        "/cash-app/security/1.0/get-login-scenario-plan",
        "/cash-app/semaphore/get-onboarding-config",
    ],
    "request-money": [
        "/cash-app/recipient-selector/search",
    ],
    "send-money": [
        "/cash-app/recipient-selector/search",
    ],
    "stock-sale": [],
    "withdraw-money": [],
};
